const AdminClients = () => {
  return (
    <div>
      <h1>Admin Clients</h1>
    </div>
  );
}

export default AdminClients;